import {createContext, useContext} from 'react';

/**
 * La manija para abrir el CRUDO de un documento, posicionado en la cita de un hecho, desde
 * cualquier objeto de la página del Booster: la carta del mazo, la fila del archivo de Memoria,
 * el ruido archivado, la cola de ruido.
 *
 * Es el mismo patrón que `sourcesDrawerContext` (la manija del modal «Documentos y notas»), y por
 * la misma razón: hasta el 2026-09-12 cada superficie que quería mostrar el crudo montaba su
 * propio `DocumentRawModal` con su propio estado, y las que no lo hacían —el archivo, donde Pablo
 * quiso verificar de dónde salía un hecho— no tenían forma de abrirlo. Con UN visor montado en la
 * página (`SourceViewerHost`) y una manija por contexto, sumar la trazabilidad a una superficie
 * nueva es una línea, y todas abren el mismo visor con el mismo gesto.
 *
 * `openSource(document, {quote})`: `document` es el objeto del listado (`documentsById[...]`) y
 * `quote` la cita textual del hecho (`fact.source_quote`); con ella el visor resalta la cita y
 * lleva hasta ahí. Sin cita abre el crudo desde el principio.
 *
 * Fuera del Booster —donde no hay provider— devuelve un no-op con `available: false`, y cada
 * consumidor decide su fallback (un texto plano, un link externo, o nada).
 */

const NOOP_VIEWER = {available: false, openSource: () => {}};

export const SourceViewerContext = createContext(null);

export function useSourceViewer() {
    return useContext(SourceViewerContext) || NOOP_VIEWER;
}
